const IMAGES = [
    {
        src: "https://images.unsplash.com/photo-1766297248084-b32bacb4a1e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxwaGFybWFjeSUyMGxhYiUyMHN0dWRlbnRzfGVufDB8fHx8MTc3NzMwNzkyM3ww&ixlib=rb-4.1.0&q=85",
        alt: "Microscope study",
        span: "lg:col-span-3 lg:row-span-2",
    },
    {
        src: "https://images.pexels.com/photos/8851729/pexels-photo-8851729.jpeg",
        alt: "Lab experiment",
        span: "lg:col-span-3",
    },
    {
        src: "https://images.unsplash.com/photo-1642130935796-1409d7e075dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjb2xsZWdlJTIwbGlicmFyeSUyMGNhbXB1c3xlbnwwfHx8fDE3NzczMDc5MjN8MA&ixlib=rb-4.1.0&q=85",
        alt: "Library shelves",
        span: "lg:col-span-3",
    },
    {
        src: "https://images.unsplash.com/photo-1766297248027-864589dbd336?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxwaGFybWFjeSUyMGxhYiUyMHN0dWRlbnRzfGVufDB8fHx8MTc3NzMwNzkyM3ww&ixlib=rb-4.1.0&q=85",
        alt: "Liquid analysis",
        span: "lg:col-span-2",
    },
    {
        src: "https://images.pexels.com/photos/15831830/pexels-photo-15831830.jpeg",
        alt: "Pharmacist with mortar",
        span: "lg:col-span-2",
    },
    {
        src: "https://images.unsplash.com/photo-1591113898691-d9e9a8144c04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxjb2xsZWdlJTIwbGlicmFyeSUyMGNhbXB1c3xlbnwwfHx8fDE3NzczMDc5MjN8MA&ixlib=rb-4.1.0&q=85",
        alt: "Campus building",
        span: "lg:col-span-2",
    },
];

export const Gallery = () => (
    <section id="gallery" data-testid="gallery-section" className="relative py-24 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
            <div className="flex items-end justify-between flex-wrap gap-6 reveal">
                <div className="max-w-xl">
                    <span className="section-rule eyebrow">Gallery</span>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[1.05] text-stone-900">
                        Moments from <em className="not-italic text-[var(--brand-blue)]">campus life</em>.
                    </h2>
                </div>
                <p className="text-stone-600 text-base md:text-lg max-w-md">
                    A glimpse into our laboratories, library and student community — where ideas
                    take shape and friendships are forged for life.
                </p>
            </div>

            <div className="mt-12 grid grid-cols-2 lg:grid-cols-6 gap-3 md:gap-4 lg:gap-5 auto-rows-[180px] md:auto-rows-[220px]">
                {IMAGES.map((img, i) => (
                    <div
                        key={i}
                        data-testid={`gallery-item-${i}`}
                        className={`zoom-wrap rounded-2xl shadow-sm reveal delay-${(i % 5) + 1} ${img.span}`}
                    >
                        <img
                            src={img.src}
                            alt={img.alt}
                            loading="lazy"
                            className="w-full h-full object-cover rounded-2xl"
                        />
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default Gallery;
